import { render, staticRenderFns } from "./VehiclePlate.vue?vue&type=template&id=2424adb0&scoped=true&"
import script from "./VehiclePlate.vue?vue&type=script&lang=js&"
export * from "./VehiclePlate.vue?vue&type=script&lang=js&"
import style0 from "./VehiclePlate.vue?vue&type=style&index=0&id=2424adb0&scoped=true&lang=scss&"
import style1 from "./VehiclePlate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2424adb0",
  null
  
)

export default component.exports